module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Cap-2-801139ea0ce7bc7114391bdcdb05e7bc.svg";